export enum StompState {
	CLOSED,
	FORCE_CLOSED,
	OPENING,
	OPEN,
	CLOSING
}
